/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PasswordResetChallengeOptions } from './PasswordResetChallengeOptions';
import {
    PasswordResetChallengeOptionsFromJSON,
    PasswordResetChallengeOptionsFromJSONTyped,
    PasswordResetChallengeOptionsToJSON,
    PasswordResetChallengeOptionsToJSONTyped,
} from './PasswordResetChallengeOptions';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface PasswordResetChallenge
 */
export interface PasswordResetChallenge {
    /**
     * 
     * @type {string}
     * @memberof PasswordResetChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof PasswordResetChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof PasswordResetChallenge
     */
    authentication_method: FactorMethod;
    /**
     * 
     * @type {PasswordResetChallengeOptions}
     * @memberof PasswordResetChallenge
     */
    options: PasswordResetChallengeOptions;
}



/**
 * Check if a given object implements the PasswordResetChallenge interface.
 */
export function instanceOfPasswordResetChallenge(value: object): value is PasswordResetChallenge {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    return true;
}

export function PasswordResetChallengeFromJSON(json: any): PasswordResetChallenge {
    return PasswordResetChallengeFromJSONTyped(json, false);
}

export function PasswordResetChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordResetChallenge {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': PasswordResetChallengeOptionsFromJSON(json['options']),
    };
}

export function PasswordResetChallengeToJSON(json: any): PasswordResetChallenge {
    return PasswordResetChallengeToJSONTyped(json, false);
}

export function PasswordResetChallengeToJSONTyped(value?: PasswordResetChallenge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ChallengeTypeToJSON(value['type']),
        'authentication_method': FactorMethodToJSON(value['authentication_method']),
        'options': PasswordResetChallengeOptionsToJSON(value['options']),
    };
}

